import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import CustomBuyForMeCard from "../customBuyForMeCard";

const ProductGrid = ({
  products = [],
  onDelete,
  onEdit,
  onShowGallery,
  selectedIds = [],
}) => {
  const { t } = useTranslation();

  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));

  if (!products || products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full gap-4">
        <div className="flex items-center justify-center">
          <XMarkIcon className="w-5 h-5 text-gray-500 me-1" />
          <span className="text-xl font-medium text-gray-500">
            {t("CartEmpty")}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2 lg:gap-4 md:mt-10 lg:grid-cols-3">
      {products.map((item) => (
        <div key={item._id}>
          <CustomBuyForMeCard
            image={item.img || "https://api.markaship.com/uploads/waiting.png"}
            title={
              item.name === "Waiting..."
                ? { en: "Waiting...", ar: "انتظر..." }
                : item.name
            }
            size={item.additionalInfo || "N/A"}
            link={item.link}
            count={item.count || "1"}
            price={roundToTwo(Number(item.price) * Number(item.count)) || "0.00"}
            status={item.status || "pending"}
            timeLeft={item.timeLeft || "0"}
            isEditable={true}
            checked={selectedIds.includes(item._id)}
            del={() => onDelete(item._id)}
            onEdit={() => onEdit(item)}
            onShowGallery={() => onShowGallery(item.imgs)}
            images={item.imgs}
          />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
